
// region JS Imports

// region External Modules
import $ from "jquery"
import u from "umbrellajs"
// endregion External Modules

// Private Modules
// Private Modules

// region Public Components
// endregion Public Components

// region Private Components
import Photoswipe_Factory from "./photoswipe/factory"
import Swiper_Factory from "components/swiper"
import StaticMap from "./map_view/index"
// endregion Private Components

// endregion JS Imports


const CELL_CLASS_NAME = "cell-serviced-apartment-building-carousel"
const CELL_INITIALIZED_CLASS_NAME = `${CELL_CLASS_NAME}--js-spacious-initialized`

const CELL_CLASS_NAME_WITH_SWIPER = "cell-serviced-apartment-building-carousel-with-swiper"
const CELL_WITH_SWIPER_INITIALIZED_CLASS_NAME = `${CELL_CLASS_NAME_WITH_SWIPER}--js-spacious-initialized`

const CELL_CLASS_NAME_MAP_VIEW = "cell-serviced-apartment-building-carousel-map-view"
const CELL_MAP_VIEW_INITIALIZED_CLASS_NAME = `${CELL_CLASS_NAME_MAP_VIEW}--js-spacious-initialized`

const init = () => {
  u(`.${CELL_CLASS_NAME}`).each((el) => {
    const $el = $(el)
    const $carousel = $el.find(".carousel")

    if (el.classList.contains(CELL_INITIALIZED_CLASS_NAME)) { return }
    el.classList.add(CELL_INITIALIZED_CLASS_NAME)

    // carousel autoplay recommended to be disabled for web vitals
    // https://web.dev/carousel-best-practices/
    $carousel.carousel("pause")

    Photoswipe_Factory.create(el, {})
  })

  u(`.${CELL_CLASS_NAME_WITH_SWIPER}`).each((el) => {
    if (el.classList.contains(CELL_WITH_SWIPER_INITIALIZED_CLASS_NAME)) { return }
    el.classList.add(CELL_WITH_SWIPER_INITIALIZED_CLASS_NAME)

    // This one is slow, one task for each element to avoid INP
    setTimeout(() => Swiper_Factory.create(el, {}), 0)
  })

  u(`.${CELL_CLASS_NAME_MAP_VIEW}`).each((el) => {
    if (el.classList.contains(CELL_MAP_VIEW_INITIALIZED_CLASS_NAME)) { return }
    el.classList.add(CELL_MAP_VIEW_INITIALIZED_CLASS_NAME)

    StaticMap.init({
      main: el,
    })
  })
}

export default {
  init,
}
